import React from 'react';

export default function Copyright() {
  return (
    <div style={{
      textAlign: 'center',
      padding: '24px 0 8px',
      borderTop: '1px solid var(--border)',
      marginTop: 32,
      color: 'var(--text-3)',
      fontSize: 12,
      letterSpacing: '0.02em'
    }}>
      © 2026 StormForge Labs LLC. All rights reserved.
    </div>
  );
}
